// * We check that if user has asset or has any transactions
import { useAPI } from '@/services/utils';
import { useFindFundByFundCode } from '../../../hooks/useFindFund';
import { useFindFundAssetByFundCode } from '../../../hooks/useFindFundAsset';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetUserStatus } from '@/userStatus/hooks';

export const useCheckHasAssetActivities = () => {
  const { isVerified } = useGetUserStatus();

  const fundCode = useGetFundCodeFromQuery();

  const { fundAsset } = useFindFundAssetByFundCode(fundCode);
  const { fund } = useFindFundByFundCode(fundCode);

  const { fundType } = fund || {};

  const { data: fundTransactions, ...fundTransactionsResponses } = useAPI(
    ['fund', 'getTransactions'],
    {
      input: {
        pageNo: 0,
        pageSize: 1,
        fundCode,
      },
      reactQueryOptions: {
        enabled: fundType === 'FUND' && isVerified,
      },
    }
  );

  const { data: etfTransactions, ...etfTransactionsResponses } = useAPI(
    ['trade', 'getEtfTransactions'],
    {
      input: {
        PageIndex: 0,
        PageSize: 1,
        Isin: fundCode,
      },
      reactQueryOptions: {
        enabled: fundType === 'ETF' && isVerified,
      },
    }
  );

  const responses =
    fundType === 'FUND' ? fundTransactionsResponses : etfTransactionsResponses;

  const hasFundTransactions =
    fundType === 'FUND' && !!fundTransactions?.items.length;
  const hasEtfTransactions =
    fundType === 'ETF' && !!etfTransactions?.items.length;

  const hasAssetActivities =
    !!fundAsset || hasFundTransactions || hasEtfTransactions;

  return { hasAssetActivities, ...responses };
};
